export default __webpack_public_path__ + "static/media/jquery.09989e75.svg";